import { useNavigate, useParams } from 'react-router-dom'
import DashboardNavigation from './DashboardNavigation'
import Footer from './Footer'
import { ChevronLeftIcon, ChevronRightIcon } from './ui'

export default function PolicyUpdateConfirmation() {
  const navigate = useNavigate()
  const { policyId } = useParams<{ policyId: string }>()

  const goToPolicy = () => {
    if (policyId) navigate(`/policy/${encodeURIComponent(policyId)}`, { replace: true })
    else navigate('/dashboard', { replace: true })
  }

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-brand-primary">
      <DashboardNavigation />

      <main id="main" className="flex w-full flex-1 flex-col">
        {/* White confirmation strip */}
        <section className="w-full shrink-0 bg-background-primary">
          <div className="mx-auto flex w-full max-w-container-desktop flex-col items-start px-[16px] py-[32px] md:px-[32px]">
            <div className="flex w-full max-w-[768px] flex-col items-start gap-6">
              <button
                type="button"
                onClick={goToPolicy}
                className="flex items-center gap-1 text-text-tertiary-600 hover:text-text-secondary-700"
              >
                <ChevronLeftIcon className="size-5 shrink-0" />
                <span className="font-body text-sm font-medium leading-sm">Back to policy</span>
              </button>

              <div className="relative flex size-[120px] shrink-0 items-center justify-center">
                <div className="absolute inset-0 rounded-full bg-[#d1fadf] opacity-50" />
                <div className="relative flex size-[100px] items-center justify-center rounded-full bg-[#d1fadf]">
                  <svg
                    className="size-14 shrink-0 text-[#12b76a]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth={2.25}
                    aria-hidden
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              </div>

              <h1 className="font-display text-display-sm font-semibold leading-display-sm text-text-primary-900">
                Your policy has been updated
              </h1>
            </div>
          </div>
        </section>

        {/* Light grey body + CTA */}
        <section className="flex w-full flex-1 flex-col bg-background-brand-primary">
          <div className="mx-auto flex w-full max-w-container-desktop flex-col items-start px-[16px] py-[32px] md:px-[32px]">
            <div className="flex w-full max-w-[768px] flex-col">
              <div className="flex flex-col gap-4">
                <h2 className="font-display text-display-xs font-semibold leading-display-xs text-text-primary-900">
                  Keep an eye on your inbox
                </h2>
                <p className="font-body font-regular text-md leading-md text-text-secondary-700">
                  We&apos;ll send you updated policy documents within the next 24 hours.
                </p>
                <p className="font-body font-regular text-md leading-md text-text-secondary-700">
                  You should receive an email, and can also download updated documents and invoices via the portal.
                </p>
              </div>

              <div className="mt-8 border-t border-border-secondary pt-6 md:mt-10 md:pt-8">
                <button
                  type="button"
                  onClick={goToPolicy}
                  className="flex w-full items-center justify-center gap-1.5 overflow-hidden rounded-md bg-background-brand-solid px-[18px] py-3 shadow-xs font-body text-md font-semibold leading-md text-text-white"
                >
                  <span>Go to policy</span>
                  <ChevronRightIcon className="size-5 shrink-0 text-text-primary-on-brand" />
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  )
}
